import { httpQuery } from '@luminovo/data-stack';
import { createFileRoute, notFound } from '@tanstack/react-router';

import { ManufacturerDetailsPage } from '@/areas/parts/ManufacturerManagement/ManufacturerDetailsPage';
import type { PageStaticData } from '@/shared/routing';

// An id the page's list lacks renders the not-found page. The cached list may predate the manufacturer, so the loader
// asks again unless it is fresh.
export const Route = createFileRoute('/_authenticated/manufacturers/$manufacturerId')({
    staticData: { access: { permissions: ['view:supplier'] }, chrome: 'home' } satisfies PageStaticData,
    loader: async ({ context: { queryClient }, params: { manufacturerId } }) => {
        const manufacturers = httpQuery('GET /manufacturers', { queryParams: { high_quality: false } });
        const lists = ({ data }: { data: { id: string }[] }) =>
            data.some((manufacturer) => manufacturer.id === manufacturerId);
        if (
            !lists(await queryClient.ensureQueryData(manufacturers)) &&
            !lists(await queryClient.fetchQuery(manufacturers))
        ) {
            throw notFound();
        }
    },
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <ManufacturerDetailsPage {...pathParams} />;
}
